export default "__VITE_ASSET__DRdDeDt9__"